import { useEffect, useState } from "react";
import { getAgentActions } from "../../../services/prompt-ai";
import { useAppInfo } from "../../../helpers/hooks/common-hook";

export default function WorkflowPanel({ toolData, setToolData }) {
	const { appId } = useAppInfo();
	const [workflowList, setWorkflowList] = useState([]);
	const [loading, setLoading] = useState(false);

	const fetchList = async () => {
		setLoading(true);
		const { data } = (await getAgentActions(appId)) || {};
		setWorkflowList(Array.isArray(data) ? data : []);
		setLoading(false);
	};

	useEffect(() => {
		if (appId) fetchList();
	}, [appId]);

	return (
		<div>
			<div className="flex justify-between items-center mb-1">
				<label className="block text-sm font-semibold text-gray-800">Workflow</label>
				<div className="flex items-center gap-2">
					<button
						type="button"
						onClick={fetchList}
						title="Refresh list"
						className="text-gray-400 hover:text-gray-700 transition-colors"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth={1.5}
							stroke="currentColor"
							className="w-4 h-4"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
							/>
						</svg>
					</button>
				</div>
			</div>
			<select
				value={toolData.workflowId || ""}
				onChange={(e) => setToolData({ ...toolData, workflowId: e.target.value })}
				disabled={loading}
				className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50"
			>
				<option value="">Select Workflow</option>
				{workflowList.map((wf) => (
					<option key={wf.id} value={wf.id}>
						{wf.name}
					</option>
				))}
			</select>
		</div>
	);
}
